'use client';
import { skipToken, useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type Workspace } from '@air/api/types';
import { useIsLoggedIn } from '@air/utils-auth';

export const WORKSPACE_KEY = '@plugin-ui/WORKSPACE';

export const getWorkspaceKey = (params: UseWorkspaceParams) => {
  return [WORKSPACE_KEY, params];
};

export type UseWorkspaceParams = {
  workspaceId: Workspace['id'] | undefined;
};

export const useWorkspace = (params: UseWorkspaceParams) => {
  const { isLoggedIn } = useIsLoggedIn();
  const workspaceId = params.workspaceId;

  return useQuery({
    queryFn: isLoggedIn && workspaceId ? () => Workspaces.get({ workspaceId }) : skipToken,
    queryKey: getWorkspaceKey(params),
  });
};
